"use client";

import { useEffect } from "react";
import { initPostHog } from "@/lib/posthog-init";

export function PostHogInit(): null {
  useEffect(() => {
    initPostHog();
  }, []);

  return null;
}
